export const FETCH_BLOGS_START = 'FETCH_BLOGS_START'
export const FETCH_BLOGS_SUCCESS = 'FETCH_BLOGS_SUCCESS'
export const FETCH_BLOGS_FAIL = 'FETCH_BLOGS_FAIL'